import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { Component, Directive, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DxFileUploaderModule, DxButtonModule, DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxRadioGroupModule, DxCheckBoxModule, DxAccordionModule, DxTabPanelModule, DxAutocompleteModule, DxNumberBoxModule, DxDropDownButtonModule, DxTabsModule, DxTemplateModule, DxTextAreaModule, DxToolbarModule, DxTreeViewModule, DxSortableModule, DxDiagramModule, DxTreeListModule, DxHtmlEditorModule, DxDropDownBoxModule, DxTooltipModule } from "devextreme-angular";

import { NavBarCubeWorkComponent } from './navbar-cubeWork.component';

import { NO_ERRORS_SCHEMA } from '@angular/core';

import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NewEmpleoyeActivitiesModule } from 'src/app/pages/sales-management/employee-activities/forms/new-empleoye-activities/new-empleoye-activities.module';
import { NewCustomerModule } from 'src/app/pages/sales-management/employee-activities/forms/new-customer/new-customer.module';
import { CreateUpdateSalesProjectModule } from 'src/app/pages/sales-management/sales-project/create-update-sales-project/create-update-sales-project.module';
import { ServicesMapModule } from 'src/app/pages/service-management/services-map/map-service/services-map.module';
import { NewServiceWorkOrderModule } from 'src/app/pages/service-management/services-map/components/new-service-work-order/new-service-work-order.module';
import { NewRfiModule } from 'src/app/pages/project-management/edit-project/new-rfi/new-rfi.module';
import { NewPushListItemModule } from 'src/app/pages/project-management/edit-project/new-push-list-item/new-push-list-item.module';
import { NewProgressReportModule } from 'src/app/pages/project-management/edit-project/new-progress-report/new-progress-report.module';
import { AlarmWorkFlowSummaryModule } from 'src/app/pages/project-management/alarm-work-flow-summary/alarm-work-flow-summary.module';
import { AlarmCustomersModule } from 'src/app/pages/sales-management/alarm-customers/alarm-customers.module';
import { NewSalesLeadModule } from 'src/app/pages/sales-management/sales-leads/modals/new-sales-lead/new-sales-lead.module';


@NgModule({
  declarations: [
    NavBarCubeWorkComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    CommonModule,
    MdbGlobalModule,
    DxCheckBoxModule,
    DxDropDownBoxModule,
    DxToolbarModule,
    DxButtonModule,
    DxTemplateModule,
    DxAutocompleteModule,
    GooglePlaceModule,
    DxTextBoxModule,
    DxPopupModule,
    DxTooltipModule,
    NewEmpleoyeActivitiesModule,
    NewCustomerModule,
    DxScrollViewModule,
    CreateUpdateSalesProjectModule,
    NewServiceWorkOrderModule,
    NewRfiModule,
    NewPushListItemModule,
    NewProgressReportModule,
    DxSelectBoxModule,
    DxDataGridModule,
    AlarmWorkFlowSummaryModule,
    AlarmCustomersModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxHtmlEditorModule,
    DxAccordionModule,
    NewSalesLeadModule
  ],
  exports: [
    NavBarCubeWorkComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NavBarCubeWorkModule { }
